import styled from "styled-components"

const Seperator = styled.div`
  border-top: 0.01em solid #c6c6c5;
  height: 1px;
`

export default Seperator
